// import redux and persist plugins
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer } from "reduxjs-toolkit-persist";
import storage from "reduxjs-toolkit-persist/lib/storage";
import persistStore from "reduxjs-toolkit-persist/es/persistStore";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "reduxjs-toolkit-persist/es/constants";

// import theme reducers
import settingsReducer from "settings/settingsSlice";
import layoutReducer from "layout/layoutSlice";
import langReducer from "lang/langSlice";
import authReducer from "auth/authSlice";
import masterReducer from "data/masterSlice";
import userReducer from "data/userSlice";
import menuReducer from "layout/nav/main-menu/menuSlice";
// import calendarReducer from "views/apps/calendar/calendarSlice";
import notificationReducer from "layout/nav/notifications/notificationSlice";
import scrollspyReducer from "components/scrollspy/scrollspySlice";

// import persist key
import { REDUX_PERSIST_KEY } from "config.js";
import configReducer from "shared/config/config.slice";
import progressLoaderReducer from "components/progress-loader/progressLoaderSlice";
import mobileVerificationModalReducer from "components/workabl-mobile-verification-modal/mobileVerificationModalSlice";
const persistConfig = {
  key: REDUX_PERSIST_KEY,
  storage,
  whitelist: ["menu", "settings", "lang", "auth"],
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    settings: settingsReducer,
    layout: layoutReducer,
    lang: langReducer,
    auth: authReducer,
    menu: menuReducer,
    masters: masterReducer,
    currentUser: userReducer,
    notification: notificationReducer,
    scrollspy: scrollspyReducer,
    config: configReducer,
    progressloader: progressLoaderReducer,
    mobileVerificationModal: mobileVerificationModalReducer
    // calendar: calendarReducer
  })
);
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
const persistedStore = persistStore(store);
export { store, persistedStore };
